import * as React from 'react';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';

type NativeDivAttributes = Pick<React.AllHTMLAttributes<HTMLDivElement>, 'id'>;

export interface HtmlDivProps extends NativeDivAttributes {
    html: HtmlString;
    className?: string;
}

export const HtmlDiv: React.FC<HtmlDivProps> = props => {
    const { html, className, ...restDivProps } = props;

    return <div {...restDivProps} className={className} dangerouslySetInnerHTML={{ __html: html.value }} />;
};
